import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { AutomationStepExecutionEntity } from './automation-step-execution.entity';
import { BaseEntity } from './base.entity';
import { MessagingConversationEntity } from './messaging-conversation.entity';
import { MessagingParticipantEntity } from './messaging-participant.entity';

export enum MessagingMessageType {
	TEXT = 'text',
	FILE = 'file',
	SYSTEM = 'system',
}

@Entity('_messaging_message')
@Index('idx_messaging_message_conversation_created', [
	'conversationId',
	'createdDate',
])
export class MessagingMessageEntity extends BaseEntity {
	@Column({
		name: 'uuid',
		type: 'varchar',
		length: 36,
		nullable: false,
	})
	@Index({ unique: true })
	public uuid!: string;

	@Column({
		name: 'fk_messaging_conversation__id',
		type: 'int',
		unsigned: true,
		nullable: false,
	})
	@Index()
	public conversationId!: number;

	@ManyToOne(() => MessagingConversationEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'CASCADE',
	})
	@JoinColumn({
		name: 'fk_messaging_conversation__id',
		referencedColumnName: 'id',
	})
	public conversation?: MessagingConversationEntity;

	@Column({
		name: 'fk_messaging_participant__id',
		type: 'int',
		unsigned: true,
		nullable: true,
		comment: 'Sender participant - null for system messages',
	})
	@Index()
	public senderParticipantId?: number;

	@ManyToOne(() => MessagingParticipantEntity, {
		onDelete: 'SET NULL',
		onUpdate: 'CASCADE',
	})
	@JoinColumn({
		name: 'fk_messaging_participant__id',
		referencedColumnName: 'id',
	})
	public senderParticipant?: MessagingParticipantEntity;

	@Column({
		name: 'message_type',
		type: 'varchar',
		length: 50,
		nullable: false,
	})
	public messageType!: MessagingMessageType;

	@Column({
		name: 'content',
		type: 'text',
		nullable: false,
		charset: 'utf8mb4',
		collation: 'utf8mb4_0900_ai_ci',
	})
	public content!: string;

	@Column({
		name: 'fk_file__id',
		type: 'int',
		unsigned: true,
		nullable: true,
	})
	public fileId?: number;

	@Column({
		name: 'mentions',
		type: 'json',
		nullable: true,
		comment: 'Array of user IDs mentioned in this message',
	})
	public mentions?: Array<number>;

	@Column({
		name: 'error_message',
		type: 'text',
		nullable: true,
	})
	public errorMessage?: string;

	@Column({
		name: 'error_code',
		type: 'varchar',
		length: 100,
		nullable: true,
	})
	public errorCode?: string;

	@Column({
		name: 'metadata',
		type: 'json',
		nullable: true,
	})
	public metadata?: Record<string, unknown>;

	@Column({
		name: 'fk__automation_step_execution__id',
		type: 'int',
		nullable: true,
		unsigned: true,
	})
	@Index()
	public automationStepExecutionId?: number;

	@ManyToOne(() => AutomationStepExecutionEntity, { nullable: true })
	@JoinColumn({ name: 'fk__automation_step_execution__id' })
	public automationStepExecution?: AutomationStepExecutionEntity;
}
